import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {
  EmCardSelectModule,
  EmCountryFlagModule,
  EmErrorBoxModule,
  EmInputModule,
  EmPrimaryButtonComponent,
  EmSelectModule,
  EmTextButtonComponent,
} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';
import {ChangeCountryComponent} from './change-country/change-country.component';
import {ChangeEmailComponent} from './change-email/change-email.component';
import {ChangeLanguageComponent} from './change-language/change-language.component';
import {ChangePasswordComponent} from './change-password/change-password.component';
import {ChangeConfirmPasswordComponent} from './change-confirm-password/change-confirm-password.component';
import {CommonWizardComponent} from './common-wizard.component';

@NgModule({
  declarations: [
    CommonWizardComponent,
    ChangeEmailComponent,
    ChangePasswordComponent,
    ChangeConfirmPasswordComponent,
    ChangeCountryComponent,
    ChangeLanguageComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    EmCountryFlagModule,
    EmErrorBoxModule,
    EmInputModule,
    EmSelectModule,
    EmPrimaryButtonComponent,
    EmTextButtonComponent,
    EmCardSelectModule,
  ],
})
export class CommonWizardModule {}
